import { Component, ErrorInfo, ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.props.onError?.(error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <Card className="m-4 border border-border rounded-lg">
          <CardContent className="p-6">
            <h3 className="text-lg font-medium text-destructive mb-2">Something went wrong</h3>
            <pre className="text-sm whitespace-pre-wrap break-words text-foreground">
              {import.meta.env.DEV ? this.state.error.message : 'An unexpected error occurred.'}
            </pre>
          </CardContent>
        </Card>
      );
    }
    return this.props.children;
  }
}
